import React from 'react'
import '../../css/underline.css';

function UnderLine() {
    return (
        <div>
            <div className="under-line"></div>
            <div className="under-line-middle"></div>
        </div>
    )
}

export default UnderLine